import { auth } from './auth.hook';
import { customer } from './customer.hook';
import { registration as registrationInternal } from './registration.hook';

export const registration = {
    ...auth,
    ...customer,
    ...registrationInternal,
};
